<div class="component-container">
  <div class="rise-playlist-container attribute-editor-component">
    <div dropdown container=".workspace-sidebar">
      <button
        matButton="outlined"
        id="addContentButton"
        [matMenuTriggerFor]="addContentMenu"
        class="mb-2 tw-w-full"
      >
        Add
      </button>
      <mat-menu #addContentMenu="matMenu">
        <button
          mat-menu-item
          id="addImageButton"
          (click)="playlistItemService.selectFiles('images')"
        >
          Image
        </button>
        <button
          mat-menu-item
          id="addVideoButton"
          (click)="playlistItemService.selectFiles('videos')"
        >
          Video
        </button>
        <button
          mat-menu-item
          id="addTextButton"
          (click)="playlistItemService.addTextWidget()"
        >
          Text
        </button>
        <button
          mat-menu-item
          id="addWidgetsButton"
          (click)="playlistItemService.addContent()"
        >
          Widgets
        </button>
      </mat-menu>
    </div>
    <div class="workspace-sidebar-body">
      <rv-sortable
        [sortableService]="sortableService"
        [shown]="placeholderPlaylistService.getItems().length"
      >
        @for (item of placeholderPlaylistService.getItems(); track item) {
          <div rvSortableItem class="templates-row">
            <rv-sortable-handle></rv-sortable-handle>
            <div>
              <streamline-icon
                aria-hidden="true"
                class="streamline-component-icon"
                name="{{ widgetUtils.getSvgIcon(item) }}"
                width="24"
                height="18"
              ></streamline-icon>
            </div>
            <div class="px-2 mr-auto u_text-ellipsis">
              <span class="templates-name" [shown]="!isEditable(item)">{{
                item.name
              }}</span>
              <a
                class="madero-link"
                actionLink
                (click)="showSettingsModal(item)"
                [shown]="isEditable(item)"
              >
                <span class="templates-name">{{ item.name }}</span>
              </a>
            </div>
            <a
              class="madero-link u_text-ellipsis edit-properties"
              actionLink
              (click)="playlistItemService.edit(item)"
            >
              @if (item.playUntilDone) {
                <span class="playlist-item-duration">PUD</span>
              } @else {
                <span class="playlist-item-duration">{{ item.duration }}s</span>
              }
            </a>
            <a
              actionLink
              (click)="placeholderPlaylistService.duplicateItem(item)"
            >
              <streamline-icon
                aria-label="Click to duplicate this item"
                class="ml-3 mr-0 streamline-component-icon"
                name="copy"
                width="16"
                height="18"
              ></streamline-icon>
            </a>
            <a actionLink (click)="remove(item)">
              <streamline-icon
                aria-label="Click to remove this item"
                class="ml-3 streamline-component-icon"
                name="trash"
                width="16"
                height="18"
              ></streamline-icon>
            </a>
          </div>
        }
      </rv-sortable>
      <!-- Empty State -->
      <div [hidden]="placeholderPlaylistService.getItems().length">
        <p class="text-muted text-center u_remove-bottom">
          Click to add Image, Video, Text or Widgets to this Playlist
        </p>
      </div>
    </div>
  </div>
</div>
